<template>
    <button
        class="btn is-ghost align-top"
        @click="this.export"
    >
        Export sales round
    </button>
</template>
<script>
    import writeXlsxFile from 'write-excel-file';

    export default {
        props: {
            addresses: {
                type: Array,
                required: true,
            },
            fileName: {
                type: String,
                required: true,
            },
        },

        data() {
            return {};
        },

        computed: {},

        methods: {
            export: function () {
                writeXlsxFile(this.addresses, {
                    schema: [
                        { column: 'Access ID', value: a => a.accessId },
                        { column: 'Address', value: a => a.address },
                        { column: 'Customer Name', value: a => a.customerName },
                        { column: 'E-mail', value: a => a.email },
                        { column: 'Mobile Phone', value: a => a.mobilePhoneNumber },
                        { column: 'Phone', value: a => a.phoneNumber },
                        { column: 'Order Status', value: a => a.orderStatus },
                        { column: 'Seller Name', value: a => a.sellerName },
                        { column: 'Delivery Project', value: a => a.deliveryProject },
                        { column: 'Sales Project', value: a => a.salesProject },
                        { column: 'Sales Round', value: a => a.salesPeriod },
                        { column: 'Sales Team', value: a => a.team },
                        { column: 'Signature Date', value: a => a.orderedAt },
                        { column: 'Campaign', value: a => a.product },
                        { column: 'Internet', value: a => a.internet },
                        { column: 'TV', value: a => a.tv },
                        { column: 'IoT', value: a => a.iot },
                        { column: 'Commissioning Date', value: a => a.activatedDate },
                        { column: 'Latest sales activity', value: a => a.latestInteraction },
                    ],
                    fileName: this.fileName + '.xlsx',
                });
            },
        },
    };
</script>
<style scoped>
</style>
